import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut, LayoutDashboard, Plus, CreditCard, Users, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  const initials = (user?.name || user?.email || "?")
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-slate-200/80">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/dashboard" data-testid="dashboard-nav-home" className="flex items-center gap-2.5">
          <span className="h-9 w-9 rounded-lg bg-[#0F172A] flex items-center justify-center">
            <ShieldCheck size={18} className="text-[#38BDF8]" />
          </span>
          <span className="font-extrabold tracking-tight text-lg text-[#0F172A]">AuthVault</span>
        </Link>

        <nav className="flex items-center gap-2">
          <Link
            to="/dashboard"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#475569] hover:bg-slate-100 transition-colors"
          >
            <LayoutDashboard size={16} /> Dashboard
          </Link>
          <Link
            to="/billing"
            data-testid="nav-billing-btn"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#475569] hover:bg-slate-100 transition-colors"
          >
            <CreditCard size={16} /> Billing
          </Link>
          <Link
            to="/team"
            data-testid="nav-team-btn"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#475569] hover:bg-slate-100 transition-colors"
          >
            <Users size={16} /> Team
          </Link>
          <Link
            to="/settings"
            data-testid="nav-settings-btn"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#475569] hover:bg-slate-100 transition-colors"
          >
            <SettingsIcon size={16} /> Settings
          </Link>
          <Link
            to="/create"
            data-testid="nav-create-form-btn"
            className="inline-flex items-center gap-1.5 rounded-lg bg-[#2563EB] px-3.5 py-2 text-sm font-semibold text-white hover:bg-[#1D4ED8] transition-all active:scale-[0.98] shadow-sm"
          >
            <Plus size={16} /> New Form
          </Link>
          <div className="flex items-center gap-2 pl-2 ml-1 border-l border-[#E2E8F0]">
            <span className="h-8 w-8 rounded-full bg-[#EFF6FF] text-[#2563EB] text-xs font-bold flex items-center justify-center">
              {initials}
            </span>
            <button
              data-testid="logout-btn"
              onClick={doLogout}
              title="Sign out"
              className="rounded-lg p-2 text-[#64748B] hover:bg-slate-100 hover:text-[#0F172A] transition-colors"
            >
              <LogOut size={16} />
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
